import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCode: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="code">
      <path
        d="M10.5 9L7.5 12L10.5 15M13.5 9L16.5 12L13.5 15M4 4H20V20H4V4Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </CentralIconBase>
  );
};

export default IconCode;
